import { IResult } from '../roundResults/store';

export interface IAdminEventResultsStore {
  [eventId: number]: {
    [flightId: number]: IResult[];
  };
}

export const adminEventResultsStore: IAdminEventResultsStore = {};
